import { validityStatus } from '@/constants/states';
import { hiddenDataModels } from './constants';

export const isValidDataModel = (status) => {
  if (status === validityStatus.INVALID) return false;
  if (status === null || status === undefined) return null;
  return true;
};

export const isVisibleDataModel = (dataModel) => (dataModel?.enabled && !hiddenDataModels.includes(dataModel.code));

export const dataModelName = (dataModel) => (isVisibleDataModel(dataModel) ? dataModel.name : '');

const visibleDataModels = (dataModels) => (dataModels.filter(isVisibleDataModel));

export default visibleDataModels;
